import { PersonVitals, PatientType } from 'redux/person/personTypes';

export const PATIENTS_SORT_STORAGE_KEY = 'patients_sort_config';

export enum PatientTableColName {
  NAME = 'patient_name',
  PATIENT_TYPE = 'patient_type',
  HEART_RATE = 'heart_rate',
  BREATHING_RATE = 'breathing_rate',
  SLEEP_DURATION = 'sleep_duration',
  SLEEP_EFFICIENCY = 'sleep_efficiency',
  PERSON_PRESENCE = 'patient_presence',
  DEVICE_NUMBER = 'device_number',
  DEVICE_MODE = 'device_mode',
  DEVICE_STATUS = 'device_status',
  DAY_SLEEP_TIME = 'day_sleep_time',
  NIGHT_SLEEP_TIME = 'night_sleep_time',
  NIGHT_AWAKE_TIME = 'night_awake_time',
  BED_EXITS = 'bed_exits',
  DETAILS = 'details'
}

export type ColumnConfigType = {
  key: PatientTableColName;
  visible: boolean;
  title: string;
  canSort?: boolean;
};

export type VisibleColumnsConfigType = Partial<{
  [key in PatientTableColName]: ColumnConfigType;
}>;

export type PatientTableColDataRangeType = {
  min: number;
  max: number;
};

export type PatientTableData = PersonVitals & {
  name: string;
  patientType?: PatientType;
  avatar?: string;
  deviceNumber?: number;
};

export interface PatientTableProps extends React.ComponentPropsWithoutRef<'table'> {
  patientTableData: PatientTableData[];
  columnsConfig: VisibleColumnsConfigType;
  onPressTableRow: (personId: string) => void;
  onDeletePatientClick?: (personId: string) => void;
  onScrollBottom?: () => void;
  onSortPatients: (sortKey: string) => void;
  hasPatientCreatePermission?: boolean;
}
